import React from "react";
import LoaderWithText from "./LoaderWithText";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import Strings from "../utils/Strings.constants";

interface LoaderModalProps {
    id?: string;
    text?: string;
    isOpen?: boolean;
}

export function LoaderModal({ id = "finalizing-modal", text = Strings.WRAPPING_UP, isOpen = true }: LoaderModalProps) {
    return (
        <Dialog open={isOpen}>
            <DialogContent className="items-center justify-center">
                <VisuallyHidden asChild>
                    <DialogTitle>{text}</DialogTitle>
                </VisuallyHidden>
                <VisuallyHidden asChild>
                    <DialogDescription />
                </VisuallyHidden>
                <LoaderWithText id={id} text={text} />
            </DialogContent>
        </Dialog>
    );
}
